export const INIT = "INIT";
export const UPDATE_RESOURCE_PARAMS = "UPDATE_RESOURCE_PARAMS";
export const SILENCE = "SILENCE";
export const RESET = "RESET";
